// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"609":"ResultsPageChunk","938":"PlaceholderPageChunk"}[chunkId] || chunkId) + "." + {"609":"84ce0298","938":"7348d222","959":"ac7317ee"}[chunkId] + ".chunk.css";
};